import { createComponent } from '@mtfe/sweet';
import Dialog, { hideDialog } from '../common/Dialog/script';
import componentUtils from '../utils/index';

import tpl from './dom.html';
import style from './style.less';

const { Describe } = componentUtils;
// 弹窗出现
const couponPopupMultMV = 'b_waimai_fsbsknc2_mv';
// 按钮点击
const couponPopupMultMc = 'b_waimai_a6m78807_mc';

// 组件ID   
const COMPONENT_ID = 'waimai_fsbsknc2';
// 组件中按钮ID
const SUB_COMPONENT_BUTTON_ID = 'waimai_a6m78807';

const describeCouponPopupMult = new Describe('CouponPopupMult', COMPONENT_ID);
const describeCouponPopupMultButton = new Describe('Button', SUB_COMPONENT_BUTTON_ID);

describeCouponPopupMult.setSubComponent('Button', describeCouponPopupMultButton);
const hideCouponPopupMult = () => {
    hideDialog();
};

const CouponPopupMult = (props = {}) => {
    const {
        title = '恭喜你',
        msg = '获得美团外卖优惠券',
        condition = '优惠券可以和满减、折扣同时享用，享折上折',
        btnText = '立即领取',
        onBtnClick,
        onClose,
        oadLX,
    } = props;
    const { isRightClose = false } = props;
    const events = {
        onrRceiveClick: () => {
            hideCouponPopupMult();
            onBtnClick && onBtnClick();
            oadLX && oadLX.mc(couponPopupMultMc);
        },
    };

    const data = {
        title,
        msg,
        condition,
        btnText,
    };
    const contentComponent = createComponent(tpl, { data, style }, events);
    oadLX && oadLX.mv(couponPopupMultMV);

    Dialog({
        contentComponent,
        isRightClose,
        onClose,
    });
};

CouponPopupMult.describe = describeCouponPopupMult
export default CouponPopupMult;

export { hideCouponPopupMult };
